import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MntStoreProductRoutingModule } from './mnt-store-product-routing.module';
import { StoreHomeComponent } from './store-home/store-home.component';
import { AddProductCartComponent } from './add-product-cart/add-product-cart.component';
import { StoreCartComponent } from './store-cart/store-cart.component';
import { StoreMasterLayoutComponent } from './store-master-layout/store-master-layout.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { AppMaterialModule } from '../app-material/app-material.module';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from "../shared/shared.module";
import { MntMasterModule } from "../mnt-master/mnt-master.module";
import { StoreCheckOutComponent } from './store-check-out/store-check-out.component';
import { PayPalPaymentComponent } from './pay-pal-payment/pay-pal-payment.component';
// import { MntInvoicesModule } from "../mnt-invoices/mnt-invoices.module";
import { FlashMessagesModule } from "angular2-flash-messages";
import { StoreStepperComponent } from './store-stepper/store-stepper.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { SquareupResponseComponent } from '../mnt-invoices/squareup-response/squareup-response.component';
import { StoreUrlNotFoundComponent } from './store-url-not-found/store-url-not-found.component'

@NgModule({
  imports: [
    CommonModule,
    MntStoreProductRoutingModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MntMasterModule,
    FlashMessagesModule
  ],
  declarations: [StoreHomeComponent, AddProductCartComponent, StoreCartComponent, StoreMasterLayoutComponent, CustomerDetailComponent, StoreCheckOutComponent, PayPalPaymentComponent, StoreStepperComponent, ThankYouComponent, SquareupResponseComponent, StoreUrlNotFoundComponent],
  entryComponents: [SquareupResponseComponent]
})
export class MntStoreProductModule { }



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-store-product/mnt-store-product.module.ts